import { environment } from './../../../../../../environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class ElasticGlobalSearchService {
    constructor(private http: HttpClient) {}

    getElasticSearchResults(keyword: string) {
        return this.http.get<any>(`${environment.elasticAPI}GlobalSearch?keyword=${encodeURIComponent(keyword)}`);
    }

    getModuleSuggestions() {
        return this.http.get<any>(`${environment.elasticAPI}GlobalSearch/Module`);
    }

    getModuleWiseFieldSuggestions(keyword: string) {
        return this.http.get<any>(`${environment.elasticAPI}GlobalSearch/ModuleField/${keyword}`);
    }
}
